// src/utils/events.ts
import { API_BASE, buildHeaders, fetchWithAuth } from "./api";

/** Запись события через серверный /api/events — сервер сам раскладывает name/payload */
export async function logEvent(
  name: string,
  payload: Record<string, any> = {}
) {
  try {
    await fetchWithAuth(`${API_BASE}/api/events`, {
      method: "POST",
      headers: buildHeaders(true),
      body: JSON.stringify({ name, payload }),
    });
  } catch {
    // проглатываем ошибки — лог не должен ломать UI
  }
}
